import React from 'react'
import Pdata from '../data/Pdata';
function Popular() {
  return (
    <>
    <div className='container'>
        <div className='row justify-content-center'>
            <div className='col-lg-8'>
            <div className='popular py-5 text-center'>
          <p className='fs-6 fw-semibold text-secondary best'>THE BEST CHOICE</p>
          <h2 className='fs-1 fw-bold py-2'>Our Popular Region</h2>
          <p className='fs-6 fw-normal'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi posuere tempor mauris, nec
             imperdiet mi rutrum eget. Donec quis ligula in tellus dictum consequat.</p>
          </div>
            </div>
        </div>
        <div className='row justify-content-center'>
      {Pdata.map((items)=>(
        <div className="col-lg-3 position-relative">
            <div className='rounded-circle mb-4  card1 ms-3' >
        <img src={items.image} width={70} className='' alt /></div>
       
        <p className='ms-5'>{items.title}</p>
      </div>
      
      ))}
      </div>
    </div></>
  )
}

export default Popular
